export const downloadFromBase64 = (fileName:string, base64:string) => {
    let byte = base64ToArrayBuffer(base64);
    var blob = new Blob([byte], {type: "application/pdf"});
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    var name = fileName;
    link.download = name;
    link.click();
}

const base64ToArrayBuffer = (base64:string) => {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
       var ascii = binaryString.charCodeAt(i);
       bytes[i] = ascii;
    }
    return bytes;
}